import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCopy, faClipboardCheck } from "@fortawesome/free-solid-svg-icons"
import PropTypes from "prop-types"
import React, { useState } from "react"
import ID from "./ID"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { Link } from "react-router-dom"

const Container = styled.span`
  font-family: "Courier New", fixed;
  color: ${(props) => props.theme.colours.identifier};
`

const LinkedID = styled(Link)`
  &:link {
    text-decoration: none;
  }
`

const Icon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colours.text.tertiary};
  margin: 0 0.5rem;
  cursor: pointer;
`
const IconCopied = styled(Icon)`
  color: ${(props) => props.theme.colours.success};
`

// Component to wrap an ID and support copying
// Note we could generalise this to any type of string
const IDCopy = ({ truncateTo, id = "", showCopy = false, linkTo }) => {
  const [isAlertVisible, setIsAlertVisible] = useState(false)
  const onCopy = () => {
    setIsAlertVisible(true)
    setTimeout(() => {
      setIsAlertVisible(false)
    }, 3000)
  }

  const truncated = truncateTo ? truncateTo : id.length
  const dispID =
    truncated < id.length
      ? "..." + id.substring(id.length - truncateTo, id.length)
      : id

  return (
    <Container onClick={(e) => e.stopPropagation()}>
      {linkTo ? (
        <LinkedID to={linkTo}>
          {" "}
          <ID title={id}> {dispID} </ID>{" "}
        </LinkedID>
      ) : (
        <ID title={id}>{dispID}</ID>
      )}
      {showCopy && !isAlertVisible && (
        <CopyToClipboard text={id} onCopy={onCopy}>
          <span>
            <Icon icon={faCopy} title="Copy to clipboard" />
          </span>
        </CopyToClipboard>
      )}
      {isAlertVisible && (
        <IconCopied icon={faClipboardCheck} title="Copied to clipboard" />
      )}
    </Container>
  )
}

IDCopy.propTypes = {
  truncateTo: PropTypes.number, // The ID will be truncated to this number of digits
  id: PropTypes.any,
  showCopy: PropTypes.bool, // Will show a copy to clipboard icon if true
  linkTo: PropTypes.string, // If provided, the actual displayed ID navigates to this react-router link when clicked.
}

export default IDCopy
